"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addOrderNote = void 0;
const addOrderNote = async (supabase, obj) => {
    const { data, error } = await supabase.from("order_notes").insert([obj]);
    if (error) {
        throw new Error(error.message);
    }
    return data;
};
exports.addOrderNote = addOrderNote;
